module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAItJREFUOE+91MEJgDAMBdAEBCfxYg7dxjE8OJbbCMUJPLiEIBW8FNv8pGDueQkhCZMjthhXuvolhOHI09nqPRjx2DFNIrI3gRqWcLhDBINBFINAC6aCVqwKerAi6MU+wRbsHzBVaemyuNhetHopHlQ9PSuqgtaZQqAFhUEUNYEIagZftGOeReTMP/YN1MxlFQ90Ss4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/返回.png
// module id = uRJ2
// module chunks = 1